<template>
  <div class="div-body">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :show-close="false"
    >
      <div class="body-dialog">
        <div class="icon-alert animate__animated animate__rotateInDownLeft">
          <div class="icon-alert-content">i</div>
        </div>
        <h5 class="title mb-0">
          Chức năng được phát triển trên ứng dụng Quản trị và Kinh doanh Du lịch.
          Để tải ứng dụng vui lòng tải tại
            <a :href="DataService.urlDownloadAppTourGuideIOS" target="_blank">AppStore</a>
          hoặc
            <a :href="DataService.urlDownloadAppTourGuideCHPlay" target="_blank">CH Play</a>
          , hoặc quét mã QR.
        </h5>
        <div class="qr-app text-center">
          <el-image
            src="img/qr-app-hdv.jpg"
            fit="cover"
            class="qr-app-img"
          ></el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DataService from '../../../service/DataService';
import Swal from 'sweetalert2';
import 'animate.css';
export default {
  data() {
    return {
      dialogVisible: false,
      DataService: DataService,
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    showAlert() {
      Swal.fire({
        icon: 'info',
        html:
          `Chức năng được phát triển trên ứng dụng Quản trị và Kinh doanh Du lịch. Để tải ứng dụng vui lòng tải tại `  +
          `<a href="${DataService.urlDownloadAppTourGuideIOS}" target="_blank">AppStore</a> `+
          `hoặc <a href="${DataService.urlDownloadAppTourGuideCHPlay}" target="_blank">CH Play</a> , hoặc quét mã QR!`
      })
    },
  },
  created() {
    setTimeout(() => {
      this.dialogVisible = true;
      // this.showAlert()
    }, 1000 * 0.7);
  },
}
</script>
<style lang="scss" scoped>
.div-body {
  height: calc(100vh - 106px);
  background: #fff;
}
::v-deep .el-dialog {
  border-radius: 5px;
  width: 500px;
  padding: 10px 15px;
  .el-dialog__header {
    padding: 0;
    border: none;
  }
  .el-dialog__body {
    border-radius: 5px;
    background: #fff;
    color: #545454;
  }
}

.body-dialog {
  padding: 10px 15px;
  word-break: break-word;
  white-space: inherit;
  text-align: center;
  .icon-alert {
    position: relative;
    box-sizing: content-box;
    justify-content: center;
    width: 5em;
    height: 5em;
    border: 0.25em solid transparent;
    border-radius: 50%;
    border-color: #000;
    font-family: inherit;
    line-height: 5em;
    cursor: default;
    border-color: #70d0f0;
    color: #3fc3ee;
    margin: 0 auto;
    .icon-alert-content {
      font-size: 60px;
    }
  }
  .title {
    margin-top: 10px;
    text-align: center;
    font-weight: 400;
    line-height: normal;
  }
  .qr-app-img {
    width: 350px;
    height: 350px;
  }
}
@media (max-width: 550px) {
  ::v-deep .el-dialog {
    width: 310px;
    margin-top: 10vh !important;
  }
  .body-dialog {
    .qr-app-img {
      width: 250px;
      height: 250px;
    }
  }
}
</style>
